import { useTranslation } from 'react-i18next';
import { AppUpdate } from '@capawesome/capacitor-app-update';

import { Button, ButtonSize, ButtonTheme } from '../../components/Button/index';
import { isPlatform } from '../../utilities/platform';
import style from './style.module.css';

const IOS_APP_ID = '6449964869';
const IOS_STORE_URL = `https://apps.apple.com/app/id${IOS_APP_ID}`;
const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=fr.stimulin';

export const UpdateAvailable = () => {
    const { t } = useTranslation();

    const handleUpdate = async () => {
        try {
            await AppUpdate.openAppStore({ appId: IOS_APP_ID });
        } catch {
            const url = isPlatform('android') ? ANDROID_STORE_URL : IOS_STORE_URL;
            window.open(url, '_blank');
        }
    };

    return (
        <div className={style.root}>
            <div className={style.title}>{t(`C'est l'heure de la\nmise à jour !`)}</div>
            <div className={style.subTitle}>
                {t(
                    `Votre App Stimul'in a été enrichie.\nPour profiter des nouvelles fonctionnalités et optimisations, nous vous invitons à la mettre à jour dès maintenant.`
                )}
            </div>
            <Button
                label={t('Mettre à jour')}
                action={handleUpdate}
                theme={ButtonTheme.PRIMARY}
                size={ButtonSize.LARGE}
                bold
            />
        </div>
    );
};
